import React from 'react';
import { CheckboxGroup } from '@here/hds-checkbox';
// eslint-disable-next-line no-new
new CheckboxGroup();
const HDSCheckboxGroup = React.forwardRef(({ children, label, secondaryLabel, ariaLabel, className, ...rest }, ref) => (React.createElement("hds-checkbox-group", { ref: ref, ...(label && { label }), ...(secondaryLabel && { 'secondary-label': secondaryLabel }), ...(className && { class: className }), ...(ariaLabel && { 'aria-label': ariaLabel }), ...rest }, children)));
HDSCheckboxGroup.defaultProps = {
    label: '',
    secondaryLabel: '',
    ariaLabel: '',
};
export default HDSCheckboxGroup;
//# sourceMappingURL=HDSCheckboxGroup.js.map